export { Flag as default } from './Flag';
